import { combineReducers } from "redux";
import cookiePersistConfig from "../store/cookieStore";
import { persistReducer } from "redux-persist";
import providers from "./searchProvidersReducer";
import locations from "./searchLocationsReducer";
import session from "./sessionReducer";
import header from "./headerReducer";
import sso from "./ssoReducer";
import dashboard from "./dashboardReducer";
import pharmacy from "./pharmacyReducer";
import healthPlan from "./healthPlanReducer";
import healthSource from "./healthSourceReducer";
import mapEvents from "./mapEventsReducer";
import error from "./errorReducer";
import openScheduling from "./openSchedulingReducer";
import domain from "./domainReducer";
import docs from "./docsReducer";
import localCache from "./localCacheReducer";
import common from "./commonReducer";
import directScheduling from "./directSchedulingReducer";
import profileTools from "./profileToolsReducer";
import portal from "./portalReducer";
import thrive from "./thriveReducer";
import healthPlanServices from "./healthPlanServicesReducer";
import epic from "./epicReducer";
import videoVisitScheduling from './videovisitSchedulingReducer';
//import dcjInbox from "./dcjInboxReducer";
import pricing from "./pricingReducer";
import memberships from "./membershipsReducer";
import marketingEmailOptIn from "./marketingEmailOptInReducer";
import inMemory from "./inMemoryReducer";
import prayerFeature from "./prayerFeatureReducer";
import inHome from "./inHomeReducer";
import myChartDataTile from "./myChartDataTileReducer";
import localStorage from "./localStorageReducer";
import careGap from "./careGapReducer";

let rootReducer = combineReducers({
    domain,
    localCache,
    sso,
    localStorage,
    providers,
    locations,
    session,
    header,
    dashboard,
    pharmacy,
    healthPlan,
    healthSource,
    mapEvents,
    error,
    openScheduling,
    docs,
    common,
    directScheduling,
    profileTools, 
    portal,
    thrive,
    epic,
    videoVisitScheduling,
    healthPlanServices,
    //dcjInbox,
    pricing,
    memberships,
    marketingEmailOptIn,
    inMemory,
    prayerFeature,
    inHome,
    careGap,
    myChartDataTile
});
rootReducer.cookiesObject = null;

export default rootReducer;
